export function padLeft(str: string, len: number): string {
  let ret = str.toString();

  while (ret.length < len) {
    ret = `0${ret}`;
  }

  return ret;
}
